export default class PromotionInfos extends HTMLSelectElement {
    constructor() {
        super();

        this.toggleField();
    }

    connectedCallback() {
        $(this).on('change', function (e) {
            this.toggleField();
        });
    }

    toggleField() {
        var valuePromotion = document.querySelector('.value_promotion');

        if(this.value == 30)
        {
            valuePromotion.classList.add('hide');

            document.querySelector('input[name="value"]').setAttribute('required', false);
        }
        else {
            valuePromotion.classList.remove('hide');

            document.querySelector('input[name="value"]').setAttribute('required', true);
        }
    }
}